import { NavLink, useLocation } from 'react-router-dom'
import { useState, useEffect } from 'react'

import '../css/navbar.css'
import arrow from '../img/icons8-chevron-abajo-30.png'
import paleta from '../img/image.png'
import whatsapp from '../img/icons8-whatsapp (2).svg'
import instagram from '../img/icons8-instagram (2).svg'
import facebook from '../img/icons8-facebook-nuevo (2).svg'

const Navbar = () => {

  const [wrapp, setWrapp] = useState(false)
  const [wrapp2, setWrapp2] = useState(false)
  const [wrapper, setWrapper] = useState(false)
  const [isDesktop, setIsDesktop] = useState(window.innerWidth)

  const location = useLocation()
  



  const changeWrapp = () => {
    setWrapp(!wrapp)
    setWrapp2(false)
  }

  const changeWrapp2 = () => {
    setWrapp2(!wrapp2)
    setWrapp(false)
  }


  const changeWrapper = () =>{
    setWrapper(!wrapper)
    if (wrapp) {
      setWrapp(false)
    }else if(wrapp2){
      setWrapp2(false)
    } 
  }

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth);
    };
  
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize',handleResize)
  }, [])
  

  return (
    
        <section className='sectionNavbar'>
            <div className='divNavbar'>
                <h1 className='logo'><NavLink className='linkName' to='/inicio'> ELSA DOMMARCO</NavLink></h1>
                <img className='imgLogo' src={paleta} alt='logo'/>
                <div className='menuWrap' onClick={()=>changeWrapper()} >
                <div className={wrapper ? 'linea1': 'linea1D'}></div>
                <div className={wrapper ? 'linea2': 'linea2D'}></div>
                <div className={wrapper ? 'linea3': 'linea3D'}></div>
                </div>                
                <nav className={wrapper ? 'navNavBarAct' :'navNavbar'}>
                  
                    <li  className={isDesktop > 992 ?'link': 'none'}   onMouseEnter={()=> setWrapp(true)} onMouseLeave={()=> setWrapp(false)}> Galeria <img style={{position:'relative',right:'-5px', top:'2.5px', width:'10px', height:'10px'}} src={arrow} alt='flecha-abajo'/> </li>
                    <li  className={isDesktop<= 992 ?'link': 'none'} onClick={() => changeWrapp()}> Galeria <img style={{position:'relative', transform:'rotate(-90deg)',right:'-5px', top:'2.5px', width:'10px', height:'10px'}} src={arrow} alt='flecha-derecha'/> </li>
  
                      <div className={wrapp ? 'wrappActive':'wrappDesactive'} onMouseEnter={()=> setWrapp(true)} onMouseLeave={()=> setWrapp(false) }>
                      <NavLink className='linkWrapp' to='/miniprint'  onClick={()=>changeWrapper()}>Miniprint</NavLink>
                      <NavLink className='linkWrapp' to='/dialogos'  onClick={()=>changeWrapper()}>Dialogos</NavLink>
                      <NavLink className='linkWrapp' to='/peces'  onClick={()=>changeWrapper()}>Peces</NavLink>
                      <NavLink className='linkWrapp' to='/pequeñosMundos'  onClick={()=>changeWrapper()}>Pequeños mundos</NavLink>
                      <NavLink className='linkWrapp' to='/intervenidos'  onClick={()=>changeWrapper()}>Intervenidos</NavLink>
                      <NavLink className='linkWrapp' to='/monocopias'  onClick={()=>changeWrapper()}>Monocopias</NavLink>
                      <NavLink className='linkWrapp' to='/profundidades'  onClick={()=>changeWrapper()}>Profundidades</NavLink>
                    </div>
                    <li  className={isDesktop > 992 ?'link': 'none'}   onMouseEnter={()=> setWrapp2(true)} onMouseLeave={()=> setWrapp2(false)}> Acerca de mi <img style={{position:'relative',right:'-5px', top:'2.5px', width:'10px', height:'10px'}} src={arrow} alt='flecha-abajo'/> </li>
                    <li  className={isDesktop<= 992 ?'link': 'none'} onClick={() => changeWrapp2()}> Acerca de mi <img style={{position:'relative', transform:'rotate(-90deg)',right:'-5px', top:'2.5px', width:'10px', height:'10px'}} src={arrow} alt='flecha-derecha'/> </li>
  
                    <div className={wrapp2 ? 'wrappActive2':'wrappDesactive2'} onMouseEnter={()=> setWrapp2(true)} onMouseLeave={()=> setWrapp2(false) }>
                      <NavLink className='linkWrapp' to='/acercaDeMi'  onClick={()=>changeWrapper()}>Acerca de mi</NavLink>
                      <NavLink className='linkWrapp' to='/premios'  onClick={()=>changeWrapper()}>Premios</NavLink>
                      <NavLink className='linkWrapp' to='/exposiciones'  onClick={()=>changeWrapper()}>Exposiciones</NavLink>
                      
                    </div>
                  
                  <NavLink className='link' to='/contacto'  onClick={()=>changeWrapper()}>Contacto</NavLink>
                  <NavLink className={location.pathname === '/inicio' || location.pathname === '/'  ? 'none': 'link'} to='/inicio'   onClick={()=>changeWrapper()}>Inicio</NavLink>
                  
                </nav>
                <div className='socialMedia'>
                  <a className='aSocialMedia' href='https://wa.me/5491141820595' target='blank'><img src={whatsapp} alt='whatsapp'/></a>
                  <a className='aSocialMedia'  href='https://www.facebook.com/elsa.dommarco' target='blanck'><img src={facebook} alt='facebook'/></a>
                  <a className='aSocialMedia'  href='https://www.instagram.com/dommarcoelsa/' target='blanck'><img src={instagram} alt='instagram'/></a>
                </div>
            </div>
        </section>
    
  )
}

export default Navbar